import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  stroke: "currentColor",
  viewBox: "0 0 34 34"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "3",
      d: "M17 32c7.456 0 13.5-6.044 13.5-13.5S24.456 5 17 5 3.5 11.044 3.5 18.5 9.544 32 17 32M22.25 13.25 17 18.5M27.5 27.5 29 32M6.5 27.5 5 32M2 6.5 6.5 2M27.5 2 32 6.5M17 5V2"
    }, null, -1)
  ])))
}
export default { render: render }